//
//
//
//
import FormComponent from './form.vue';
export default {
  name: 'order-purchase-create',
  components: {
    FormComponent: FormComponent
  },
  data: function data() {
    return {
      id: 0
    };
  }
};